// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1V0N6","row":"ProcedureTreatmentSummary_row__2zLmo"};